var map = {
	"./policy-cn.png": "M0fL",
	"./policy-de.png": "rhrY",
	"./policy-en.png": "LXNK",
	"./policy-es.png": "j51G",
	"./policy-fr.png": "CAte",
	"./policy-pt.png": "jy+e"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RHPZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copyright/policy ^\.\/policy\-.*\.png$
// module id = RHPZ
// module chunks = 1